import React from 'react'
import style from '../../../styles/mystyle.module.css'
import { useTranslation } from 'next-i18next'
import * as config from '../../../next.config.js'
import {useRouter} from 'next/router'
import { getWeekDates,processWorkingTimeData ,getNextTimeForZeroFreq} from "../../helpers/global/datesTimes/datesTimesFunctions"
function WorkTimesComp({ entityId,StatusIds,days,workTimes }) {
    const { locale } = useRouter();
    const { t } = useTranslation("common")
    let tLang = {
        "am": t("am"),
        "pm": t("pm")
    }
    const [lstMedicalDataWorkTimes, setLstMedicalDataWorkTimes] = React.useState([])
    React.useEffect(() => {
    let status = StatusIds
    let data={workTime:workTimes,id:entityId}
        // console.log("data=======>",data,days,status)
    let temp=processWorkingTimeData(data,days,status) 
    setLstMedicalDataWorkTimes(temp)
    }, [entityId,workTimes])
    return (
           <>
        
            {
                
                lstMedicalDataWorkTimes && lstMedicalDataWorkTimes.length > 0 && lstMedicalDataWorkTimes.filter(
                    (i, x) => x === lstMedicalDataWorkTimes.findIndex(w => w.dayId === i.dayId)
                ) ?
                    <>
                        <div className={style.SectionContainer}>
                            <div className={style.allcard}>
                                <div className={style.TitleandIcons} >
                                    <div> <img className={style.icontitle} src={`${config.basePath}/assest/WorkTime.png`} alt={"working-time"} width={50} height={50} /></div>
                                    <div className={style.hLine9 + " " + style.paddingZero} >{t("WorkTime")} </div>
                                </div>
                                {
                                    getWeekDates(new Date(), 6).map(weekDay => {
                                        return (
                                            lstMedicalDataWorkTimes.filter(
                                                (i, x) => x === lstMedicalDataWorkTimes.findIndex(w => w.dayId === i.dayId)
                                            ).filter(workDay => workDay.dayName && workDay.dayName.toLowerCase() == weekDay.dayJson.code.toLowerCase()).map((workDay, index2) => {
                                                return (
                                                    <div  key={index2}>
                                                        <div className={style.aboutText}>
                                                            <ul style={{
                                                                listStyle: "none",
                                                                marginBottom:"0.5rem", 
                                                                padding: locale =="ar"?"0 8px 0 0 " : "0 8px 0 0 "
                                                            }}>
                                                                <li >{
                                                                    (weekDay.currentDate == new Date().getDate()) ?
                                                                       <span className={style.flexli}>  <div className={style.Circle + " " + style.marginZero} > </div>{t("Today")}</span> 
                                                                        :
                                                                        weekDay.currentDate == (new Date().getDate() + 1) ?
                                                                        <span className={style.flexli}>  <div className={style.Circle + " " + style.marginZero} > </div> {t("Tomorrow")}</span> 
                                                                         : 
                                                                         <span className={style.flexli}>  <div className={style.Circle + " " + style.marginZero} > </div>{weekDay.dayJson.name}
                                                                      
                                                                         </span> 
                                                                }
                                                                    <ul style={{
                                                                        listStyle: "none"
                                                                    }}>
                                                                        {
                                                                            workDay.newList.sort((a, b) => a.fromTime - b.fromTime).map(timeItem => {
                                                                                let temptimes = getNextTimeForZeroFreq(timeItem.fromTime, timeItem.toTime, 0, { ...tLang })
                                                                                temptimes.forEach(item => {
                                                                                    item[0] = (item[0] % 12) || 12
                                                                                })

                                                                                return (
                                                                                    <li style={{padding:locale == "ar" ? "  0 20px 0  0" : "  0 0 0  20px" }}>
                                                                                         <div className={style.flexli} key={index2}>
                                                                                        <span><div className={style.CircleLi  } > </div></span>
                                                                                        {t("From")}
                                                                                        {` ${temptimes[0][0]}:${temptimes[0][1]} ${temptimes[0][2]} `}
                                                                                        {t("To")}
                                                                                        {` ${temptimes[1][0]}:${temptimes[1][1]} ${temptimes[1][2]} `}</div>
                                                                                    </li>
                                                                                )
                                                                            })
                                                                        }

                                                                    </ul>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </>
                    :
                    ""
            }
        </>
        
    )
}

export default WorkTimesComp
